import {Injectable} from '@angular/core';
import {HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HTTP_INTERCEPTORS} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize, tap} from 'rxjs/operators';
import { LoadingService } from '../../shared/loading/loading.service';


@Injectable()
export class LoaderInterceptor implements HttpInterceptor  {
  private requests: HttpRequest<any>[] = [];
  constructor(private loaderService: LoadingService) {

  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(req.url.includes("assets/config.dev.json")){
      return next.handle(req).pipe(
       // finalize(() => this.loaderService.closeLoading())
     );
    }else{
   // this.loaderService.showloading();
      return next.handle(req).pipe(
     //   finalize(() => this.loaderService.closeLoading())
      );
    }

}


}
